import React from 'react';
import MembersList from './MembersList';
import ScribeHoursAndProLicenses from './ScribeHoursAndProLicenses';
const Members = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ScribeHoursAndProLicenses, null),
        React.createElement(MembersList, null)));
};
export default Members;
